import { type JSX } from 'react';

import { EloTooltip } from '@plurall/elo-v3';

import { useIsMobile } from '@/hooks/useIsMobile';

import { AppNavIconButton } from '../AppNavIconButton/AppNavIconButton';
import {
  NavEndFactory,
  NavRootFactory,
  NavStartFactory,
} from '../GlobalNavigation/factories/global-navigation-factory';
import { HelpMenu } from '../HelpMenu/HelpMenu';
import { Logo } from '../Logo/Logo';
import { ProfileMenu } from '../ProfileMenu/ProfileMenu';

type HomeTopBarProps = {
  onToggle: () => void;
  isMenuOpen?: boolean;
};

export function HomeTopBar({ onToggle, isMenuOpen = false }: HomeTopBarProps): JSX.Element {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <NavRootFactory isOpen={isMenuOpen}>
        <NavStartFactory isOpen={isMenuOpen}>
          <AppNavIconButton
            aria-label={isMenuOpen ? 'Fechar Menu' : 'Abrir Menu'}
            icon={isMenuOpen ? 'cancel' : 'menu-burger'}
            onClick={onToggle}
          />
          <Logo />
        </NavStartFactory>
      </NavRootFactory>
    );
  }

  const toggleTooltip = isMenuOpen ? 'Esconder Menu' : 'Fixar Menu';

  return (
    <NavRootFactory>
      <NavStartFactory>
        <EloTooltip
          content={toggleTooltip}
          position='bottom'
          size='small'
          openDelay={300}>
          <AppNavIconButton
            onClick={onToggle}
            aria-label={toggleTooltip}
            icon='menu-burger'
          />
        </EloTooltip>
        <Logo />
      </NavStartFactory>

      <NavEndFactory>
        <HelpMenu />
        <ProfileMenu />
      </NavEndFactory>
    </NavRootFactory>
  );
}
